/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Purpose_TitleInputs */

const da_privacy_purpose_title = /** @type {(inputs: Privacy_Purpose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formål og retsgrundlag`)
};

/** @type {(inputs: Privacy_Purpose_TitleInputs) => LocalizedString} */
const en_privacy_purpose_title = da_privacy_purpose_title;

/**

* @param {Privacy_Purpose_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_purpose_title = /** @type {((inputs?: Privacy_Purpose_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Purpose_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_purpose_title(inputs)
	return /** @type {LocalizedString} */ ("Formål og retsgrundlag")
});